import {Item, Rental} from "./types";
import React from "react";
import {
    CloseButton,
    layout,
    theme,
    typography,
    View,
    ViewContent,
    ViewHeader,
    ViewHeaderItem,
} from "@variocube/cube-ui";
import {Occupancy} from "@variocube/app-api";
import {RentalTable} from "./RentalTable";
import {useLocalization} from "../i18n";

interface BorrowerRentalListViewProps {
    rentals: Rental[];
    items: Item[];
    occupancies: Occupancy[];
    onRentalSelect: (rental: Rental) => void;
    onClose: () => void;
}

export function BorrowerRentalListView({onClose, ...props}: BorrowerRentalListViewProps) {
    const {t} = useLocalization();

    return (
        <View>
            <ViewHeader className={theme.lessContrast}>
                <ViewHeaderItem fill className={layout.paddingMedium}>
                    <div className={typography.title}>{t("Rental")}</div>
                </ViewHeaderItem>
                <CloseButton label={t("Close")} onClick={onClose}/>
            </ViewHeader>
            <ViewContent>
                <RentalTable {...props} />
            </ViewContent>
        </View>
    )
}
